import { render } from "./DefaultOnePagePostDetailCmp.vue?vue&type=template&id=35ba5a6a"
import script from "./DefaultOnePagePostDetailCmp.vue?vue&type=script&lang=js"
export * from "./DefaultOnePagePostDetailCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__